import Box from "@mui/material/Box";
import { ReactComponent as EmptyIcon } from "assets/icon_address_emty.svg";
import { useTranslation } from "react-i18next";

const EmptyData = () => {
  const [t] = useTranslation();

  return (
    <Box
      sx={{
        height: "500px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--gray-text)"
      }}
    >
      <EmptyIcon
        style={{
          width: "100px",
          height: "100px",
          marginBottom: "20px",
          opacity: 0.6
        }}
      />
      <Box>
        {t("addressEncoding.emtyData")}
      </Box>
    </Box>
  );
};

export default EmptyData;
